var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"column__tool__buttom",attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onClickDelete()}}},[_vm._v("删除")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }